module.exports = __webpack_public_path__ + "img/iq.bfdb80ad.svg";